import { useEffect, useState } from 'react';
import { isTextEntryTarget } from '@/lib/text-entry';

const asElement = (target: EventTarget | null) =>
  target instanceof HTMLElement ? target : null;

/** Whether a field that opens the on-screen keyboard has focus. */
export function useTextEntryFocused(): boolean {
  const [focused, setFocused] = useState(() =>
    typeof document === 'undefined'
      ? false
      : isTextEntryTarget(asElement(document.activeElement))
  );

  useEffect(() => {
    const onFocusIn = (event: FocusEvent) =>
      setFocused(isTextEntryTarget(asElement(event.target)));
    // `relatedTarget` is where focus goes next (null when it leaves).
    const onFocusOut = (event: FocusEvent) =>
      setFocused(isTextEntryTarget(asElement(event.relatedTarget)));

    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);
    return () => {
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
    };
  }, []);

  return focused;
}
